// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "Arc-module--arrow-up-and-down--4aea0";
export var container = "Arc-module--container--b9445";
export var leftBorder = "Arc-module--leftBorder--415aa";
export var showOnlyInDesktop = "Arc-module--showOnlyInDesktop--7f9ef";